import * as Constantes from '../../../shared/constants';

// componentes
import { Component, OnInit, ViewChild } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ActivatedRoute, Router } from '@angular/router';

// Modelos e Interfaces
import { IAvisos } from 'src/app/interfaces/avisos';
import { ICliente } from 'src/app/interfaces/cliente';
import { IAvisosOpciones } from './avisosListOpciones';
import { ITipoDeAvisos, MTipoDeAvisos } from './../../../models/tipoAvisos';

// Servicios
import { AvisosService } from 'src/app/services/datos/avisos.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { ClientesService } from 'src/app/services/datos/clientes.service';

// Librerias
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { PedidosService } from 'src/app/services/datos/pedidos.service';
import FuncLib from 'src/app/providers/funcionesLib';

@Component({
  selector: 'app-avisos',
  templateUrl: './avisos.component.html',
  styleUrls: ['./avisos.component.scss'],
})
export class AvisosComponent implements OnInit {

  // Librería de funciones
  public funcLib: FuncLib = new FuncLib();

  // Usar constantes en el template
  Constantes = Constantes;

  parametrosUrl: any; // Parámetro desde CampanyaNueva.Component
  loading: boolean = false;

  textoDestacado: string = '';
  public strBuscarTodo: string = '';

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado',
  };

  avisosList: IAvisos[] = [];
  clientesList: ICliente[] = [];

  public tiposDeAviso: ITipoDeAvisos[] = MTipoDeAvisos;

  rows: IAvisos[] = [];
  temp: any[] = [];

  columns = [];
  ColumnMode = ColumnMode;

  cliSeleccionado: string = '';
  tipoSeleccionado: string | null = null;
  leidoSeleccionado: string | null = null;

  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  public imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  @ViewChild(AvisosComponent) table: AvisosComponent | any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public avisosSrv: AvisosService,
    private notificSrv: NotificacionesService,
    private clientesSrv: ClientesService,
    private pedidosSrv: PedidosService
  ) { }

  ngOnDestroy(): void { }

  ngOnInit(): void {
    // Mirar si pasan parámetros
    this.route.queryParams.subscribe((params) => {
      this.parametrosUrl = params || {};

      console.log('_recibido parametrosUrl:', this.parametrosUrl);
      if (this.parametrosUrl.id_cliente)
        this.cliSeleccionado = this.parametrosUrl.id_cliente;
      if (this.parametrosUrl.id) {
      }
    });

    this.getClientesList();
    this.getListaAvisos();
  }

  getListaAvisos() {
    const avisosOpciones: IAvisosOpciones = {};
    avisosOpciones.id_cliente = parseInt(this.cliSeleccionado);
    avisosOpciones.tipo = this.tipoSeleccionado;
    avisosOpciones.leido = this.leidoSeleccionado;

    this.loading = true;
    this.avisosSrv.getAvisosList(avisosOpciones).subscribe((resp) => {
      this.loading = false;
      console.log('__getListaAvisos()', resp);
      this.avisosList = resp.data;
      this.rows = this.avisosList;
      this.temp = [...this.avisosList];
    });
  }

  getClientesList() {
    this.loading = true;
    this.clientesSrv.getLista().subscribe((resp) => {
      this.loading = false;
      this.clientesList = resp.data.filter(
        (cliente: { archivado: boolean }) => !cliente.archivado
      );
    });
  }

  // Búscar y filtrar

  filtro(val: string, campo: string) {
    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d[campo]) return d[campo].toLowerCase().indexOf(val) !== -1 || !val;
      return !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.avisosList;
  }

  buscar(event: any, campo: string) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    this.filtro(txt, campo);
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.avisosList;
  }

  buscaGlobal(txt: string) {
    const temp = this.temp.filter((d: any) =>
      Object.keys(d).some(
        (key: any) =>
          d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    // Marcar el texto destacado
    this.textoDestacado = txt;

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table = this.avisosList;
  }

  limpiaBusca() {
    this.strBuscarTodo = '';
    this.buscaGlobal('');
    const buscaTodoInput = document.getElementById('buscaTodo');
    buscaTodoInput?.focus();
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr);
  }

  // Filtros

  onClienteSelect(id: string) {
    this.cliSeleccionado = id;
    this.getListaAvisos();
    this.strBuscarTodo = '';
  }

  onTipoSelect(tipo: string | null) {
    this.tipoSeleccionado = tipo;
    this.getListaAvisos();
    this.strBuscarTodo = '';
  }

  onLeidoSelect(leido: string | null) {
    this.leidoSeleccionado = leido;
    this.getListaAvisos();
    this.strBuscarTodo = '';
  }

  abrirPedido(row: IAvisos) {
    const id_pedido = Number(row.buscar_pedido);

    if (isNaN(id_pedido)) {
      this.notificSrv.aviso(
        'error',
        `No se ha encontrado el pedido ${row.buscar_pedido}`
      );
      return;
    }

    this.pedidosSrv.getPedido(id_pedido).subscribe((resp) => {
      if (resp.error) {
        this.notificSrv.aviso('error', resp.mensaje);
        return;
      }

      this.router.navigate(['panel/pedidos_lista', id_pedido]);
    });
  }

  //  CRUD  //

  abrirMsg(row: any) {
    Swal.fire({
      title: 'Ver mensaje',
      icon: 'info',
      html: ` <b>Mensaje:</b> ${row.mensaje}`,
      showCancelButton: true,
      cancelButtonText: 'Cerrar',
      showConfirmButton: false,
    });
  }

  deleteRow(row: any) {
    Swal.fire({
      title: '¿Borrar mensaje?',
      icon: 'question',
      html: ` <b>Eliminar</b> ${row.mensaje}`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.avisosSrv.delete(row.id).subscribe((resp) => {
          if (resp.error) {
            this.notificSrv.aviso('error', resp.mensaje);
          } else {
            this.notificSrv.aviso('info', `Registro eliminado`);
            this.rows = this.rows.filter((objeto) => objeto.id !== row.id);
          }
        });
      }
    });
  }

  // AUX  //

  // EXPORTAR A EXCEL
  exportToExcel(): void {
    const fileName = `articulos-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Mensajes a Clientes');
    XLSX.writeFile(workbook, fileName);
  }
}
